<template>
  <VideoTitle
    :title="title"
    :from="fromType"
    :isLove="isLove"
    @changeLoveStatus="changeLoveStatus"
    @bakToPrev="bakToPrev"
  >
    <template v-if="!$route.meta.keepAlive">
      <router-view
        ref="myChild"
        @emitChangeLove="emitChangeLove"
        @changeFromTitle="changeFromTitle"
        @changeFromType="changeFromType"
      ></router-view>
    </template>
    <template v-else>
      <router-view
        ref="myChild"
        @emitChangeLove="emitChangeLove"
        @changeFromTitle="changeFromTitle"
        @changeFromType="changeFromType"
      ></router-view>
    </template>
  </VideoTitle>
</template>
<script>
import VideoTitle from "@/components/StudyCenter/VideoTitle";
export default {
  name: "review-home",
  data() {
    return {
      title: "",
      isLove: false,
      fromType: "main",
    };
  },
  components: {
    VideoTitle,
  },
  methods: {
    bakToPrev() {
      console.log(this.$route.path);
      if (this.$route.path == "/Video/VideoQuestions") {
        this.$router.go(-1);
      } else {
        this.$router.push({
          path: "/StudyCenter",
        });
      }
    },
    changeLoveStatus() {
      this.$refs.myChild.changeLike();
    },
    emitChangeLove(v) {
      this.isLove = v;
    },
    getData() {
      console.log("getData");
    },
    changeFromType(v) {
      this.fromType = v;
    },
    changeFromTitle(v) {
      this.title = v;
    },
  },
};
</script>